module.exports = __webpack_public_path__ + "static/media/vent-direccio-20.4d7b496b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/vent-direccio-20.svg
// module id = 208
// module chunks = 0